import { api } from './AuthContext';
export const matrimonyAPI = {
  getMatches: () => api('/matrimony/matches/'), 
  getAbout: () => api('/matrimony/about/'),
  getPaymentCfg: () => api('/matrimony/payment-config/'), 
  getProfileFormConfig: () => api('/matrimony/profile-form-config/'),
  getProfile: () => api('/matrimony/profile/'),
  updateProfile: (b) => api('/matrimony/profile/', 'PUT', b), 
  submitPayment: (b) => api('/matrimony/payments/', 'POST', b),
  sendMessage: (b) => api('/matrimony/contact/', 'POST', b),
};
export const decorAPI = {
  getAbout: () => api('/decor/about/'), getCatalog: (cat) => api(`/decor/catalog/${cat ? `?category=${cat}` : ''}`),
  submitQuote: (b) => api('/decor/quotes/', 'POST', b), submitBooking: (b) => api('/decor/bookings/', 'POST', b),
  getUpcoming: () => api('/decor/bookings/upcoming/'), getContact: () => api('/decor/contact/'),
  sendMessage: (b) => api('/decor/contact/message/', 'POST', b),
};
export const cateringAPI = {
  getAbout: () => api('/catering/about/'), getTeam: () => api('/catering/team/'),
  getPackages: (q) => api(`/catering/packages/${q ? `?${q}` : ''}`), submitQuote: (b) => api('/catering/quotes/', 'POST', b),
  submitBooking: (b) => api('/catering/bookings/', 'POST', b), getUpcoming: () => api('/catering/bookings/upcoming/'),
  getContact: () => api('/catering/contact/'), sendMessage: (b) => api('/catering/contact/message/', 'POST', b),
};
